<template>
  <div class="excelsheet">
    <!-- <div style="position: absolute;top:0;"> -->
      <v-card
      class="pl-3 pr-3 pt-3 pb-3"
      >
    <slot name="top"> 
  
     
     </slot>
     <!-- class="ma-2" -->
     <v-btn
    style="margin-left:12px;"
     color="primary"
     @click="( () => downloadExcel())"
   >
     Download Excel
   </v-btn>
  </v-card>
<!-- absolute
position: relative; -->
    <!-- <div  v-if="!boolWindow"
      id="luckysheet"
      style="margin:0px;padding:0px;position:absolute !important;width:100%;left: 0px; top:15vh ;bottom:0px;"
    ></div>


    <div  v-if="boolWindow"
    id="luckysheet"
    style="margin:0px;padding:0px;position:relative !important;width:100%;left: 0px; top:vh ;bottom:0px;"
  ></div> -->
    <!-- top: 70px -->


    <div 
      id="luckysheet"
      style="margin:0px;padding:0px;position:relative !important;width:100%;left: 0px; top:0vh ; height:90vh; "
    ></div>

 
 
    <!-- <div v-show="isMaskShow" style="position: absolute;z-index: 1000000;left: 0px;top: 0px;bottom: 0px;right: 0px; background: rgba(255, 255, 255, 0.8); text-align: center;font-size: 40px;align-items:center;justify-content: center;display:flex;">Downloading</div> -->

  </div>
</template>

<script setup>


import { ref, onMounted, computed, toRefs, watch } from 'vue'
import LuckyExcel from 'luckyexcel'
//导入库export.js 这个文件是es6的，不能在普通的HTML文件直接引入js文件（虽然都是js文件，但是有区别，具体请百度es6与es5）！需要把es6转es5才可以直接引入使用！
import {testaaa,exportExcel} from './export'
// import {exportExcel} from './exportFromOther'
import moment from '@/utils/moment'
import { useRoute, useRouter } from 'vue-router/composables';


const props = defineProps({
 centerID: {
    type: Number,
    default: 0,
      },
        theDate: {
          type: String,
          default:  moment().format('YYYY-MM-DD')
 
        },
   fileName: {
    type: String,
    default: 'templateFile',
      },
      importData: {
        type: Object,
 
      },
      merge: {
        type: Array,
   
      }
      
   
 
      })
    


const { centerID, theDate ,  fileName , enableSelect ,importData  , merge  } = toRefs(props)

// const boolWindow = ref(false)
 
onMounted(() => {
  // try{
 
//   const route = useRoute();
// // console.log('route.query.boolWindow',route.query.boolwindow )
//  if (Boolean(route.query.boolwindow)){
//   boolWindow.value = Boolean(route.query.boolwindow)
//    console.log('boolWindow.value',boolWindow.value)
//  }
  
 
//  }catch (ex)
//  {
//   console.log('error',ex)
//  }

 
  
})

watch(importData,  newValue => {
   console.log('watch(importData',newValue)

  if (newValue != {}){
    console.log('newValue')
    initLuckysheet(newValue)
  }
 
 

}, 
// { deep: true }
)


function initLuckysheet(data) {

  luckysheet.create(data);


  luckysheet.setRangeShow("I30")


  // luckysheet.setCellFormat(1, "Sheet1", 2, 0);

  // luckysheet.setCellValue(0, 1, 1);

  // luckysheet.setCellFormat(0, 0, "bd", {borderType: "border-right",style: "1", color: "#ff0000"})
  // luckysheet.setColumnWidth({0: 'auto', 2: 'auto'})
  
}

  
 
         
function  jsonToCelldata(jsonData) {
    const headers = ['Locker No', 'Locker Size', 'Locker Status', 'Current User', 'Transaction Date', 'Action'   , 'User'];
  console.log('jsonData',jsonData)
  const celldata = [];

  jsonData.forEach((item, row) => {
    if (row < 5) {
      //please check theitem.fs
      // const fs = value === undefined ? 12 : item.fs;
  
      const infoCell = {
        r: row,
        c: 0,
        v: { m: item.Info, ct: { fa: 'General', t: 's' }, v: item.Info , fs: item.fs ? item.fs : 12 },
      };
      celldata.push(infoCell);
    } else {
      if (row === 5) {
        headers.forEach((header, c) => {
          celldata.push({
            r: row,
            c,
            v: { m: header, ct: { fa: 'General', t: 's' }, v: header , bg : item.bg ? item.bg  : '#FFFFFFF'  },
          });
        });
      } else {
        const rowData = [
          item.lockerNo,
          item.lockerSize,
          item.lockerStatus ,
          item.currentUser ? item.currentUser : '',
          item.transactionDate  ,
          item.action ? item.action : '',
          item.user ? item.user : '',
        ];
      

        rowData.forEach((value, c) => {
          console.log('rowData.forEach((value' , value)
          const stringValue = value === undefined ? '' : value.toString();
           

          const cell = {
            r: row,
            c,
            v: {
              m: stringValue,
              ct: { fa: 'General', t: typeof value === 'number' ? 'n' : 's' },
              v: stringValue,
              bg : item.bg ? item.bg : '#FFFFFF'
            },
          };
          celldata.push(cell);
        });
      }
    }
  });
console.log('celldata',celldata)
  return celldata;
}

 function calculateColumnWidths(celldata) {
  const colWidths = {};

  celldata.forEach((cell) => {
    const { c, v } = cell;
    const content = v.v;
    const width = content.toString().length * 10; // 10 is an approximate width per character

    if (!colWidths[c] || width > colWidths[c]) {
      colWidths[c] = width;
    }
  });
 
  return colWidths;
}

function calculateColumnHeights(celldata) {
  const colHeights = {};

  celldata.forEach((cell) => {
    
    const { c, r } = cell;
    // const content = v.v;
    // const lines = content.toString().split(/\r\n|\r|\n/).length; // Count the number of lines in the content
    const fontSize =    cell.v.fs ?  cell.v.fs  :  12
    const lineHeight = fontSize * 1.2; // Calculate the line height based on the font size, assuming 1.2x the font size as a standard
    const height = lineHeight;

    if (!colHeights[r] || height > colHeights[r]) {
      colHeights[r] = height;
    }
  });

  return colHeights;
}


 function   resizeWindow(width, height) {
    window.resizeTo(width, height);
  }

  function uploadExcel(evt){
        const files = evt.target.files;
        if(files==null || files.length==0){
            alert("No files wait for import");
            return;
        }

        let name = files[0].name;
        let suffixArr = name.split("."), suffix = suffixArr[suffixArr.length-1];
        if(suffix!="xlsx"){
            alert("Currently only supports the import of xlsx files");
            return;
        }
        LuckyExcel.transformExcelToLucky(files[0], function(exportJson, luckysheetfile){

            if(exportJson.sheets==null || exportJson.sheets.length==0){
                alert("Failed to read the content of the excel file, currently does not support xls files!");
                return;
            }
            window.luckysheet.destroy();

            window.luckysheet.create({
                container: 'luckysheet', //luckysheet is the container id
                showinfobar:false,
                data:exportJson.sheets,
                title:exportJson.info.name,
                userInfo:exportJson.info.name.creator
            });
        });
    }

  function  selectExcel(evt){
        const value = this.selected;
        const name = evt.target.options[evt.target.selectedIndex].innerText;

        if(value==""){
            return;
        }
        this.isMaskShow = true;

        LuckyExcel.transformExcelToLuckyByUrl(value, name, (exportJson, luckysheetfile) => {

            if(exportJson.sheets==null || exportJson.sheets.length==0){
                alert("Failed to read the content of the excel file, currently does not support xls files!");
                return;
            }

            this.isMaskShow = false;
            window.luckysheet.destroy();

            window.luckysheet.create({
                container: 'luckysheet', //luckysheet is the container id
                showinfobar:false,
                data:exportJson.sheets,
                title:exportJson.info.name,
                userInfo:exportJson.info.name.creator
            });
        });
    }

   function downloadExcel(){

      exportExcel(luckysheet.getAllSheets(), fileName.value)
 
    }

 

  
 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
 
</style>
